module.exports = (__parcel__import__("116ci")).then(() => parcelRequire('8OYBW'));